/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2022-11-09 15:41:00
 */

 import * as Vue from 'vue-tsx-support';
 import { Component, Prop } from 'vue-property-decorator';
 import 'vue-tsx-support/enable-check';
 import Modal from 'src/types/iview/Modal';
 import Button from 'src/types/iview/Button';
 import Input from 'src/types/iview/Input';
 import { Toast } from 'src/util/toast';
 import { modalFactory } from 'src/util/vueExtend';
 import EnumOperates from 'src/enums/enumOperates';
 import { Integer } from 'src/types/base';
 import EntitySelect from 'src/components/SelectCustom/entitySelect';
 import EnumEntity from 'src/enums/enumEntity';
 import InputNumber from 'src/types/iview/InputNumber';
import TestApi, {TestDOI} from './api/testApi'
 import { createNamespace } from 'src/util/bem';
 import EnumMaintenanceAuditStatus from 'src/enums/enumMaintenanceAuditStatus';
 import { DateTimeUtil } from 'src/util/dateTimeUtil';
 import  DatePicker from 'src/types/iview/DatePicker';
 import EnumAlarmType from 'src/enums/enumAlarmType';
 import CommonSelect from 'src/components/SelectCustom/commonSelect';

export namespace solutionKeyVOI {
    export interface PropsI {
        operate: string;
        id?: number;

        saveSuccess?(): void;

        cancel?(): void;
    }

    export interface FormDataI {
        error_no: string;
        error_info: string;
    }
}

let uid = 1;

@Component
class SolutionKeyAddModel extends Vue.Component<solutionKeyVOI.PropsI> {
    @Prop({
        type: Function,
    })
    cancel!: () => void;

    @Prop({
        type: Number,
    })
    id!: number;

    @Prop({
        type: String,
    })
    operate!: string;

    @Prop({
        type: Function,
    })
    saveSuccess!: () => void;

    visible: boolean = false;

    loading: boolean = false;

    formData: solutionKeyVOI.FormDataI = {
        error_no: "",
        error_info: "",
    };
    rules: any = {};

    close() {
        this.cancel && this.cancel();
        this.closeModal();
    }

    closeModal() {
        this.visible = false;
        this.$emit('close', false);
    }

    async save() {
        if (!(await this.$validate('formValidate'))) {
            return;
        }
        let res;
        this.loading = true;
        let params: TestDOI.FormDataI = {
            ...this.formData,
        };
        switch (this.operate) {
            case EnumOperates.Add.getName():
                res = await TestApi.add(params);
                break;
            case EnumOperates.Update.getName():
                params.id = this.id;
                res = await TestApi.update(params);
                break;
                break;
        }
        this.loading = false;
        let { code } = res;
        if (code === 0) {
            Toast.success(this.operate + '成功');
            this.saveSuccess();
            this.closeModal();
        }
    }
    async mounted() {
        if (this.operate === EnumOperates.Update.getName()) {
            let { code, data } = await TestApi.searchDetail(this.id);
            if (code === 0) {
                this.formData.error_info = data['error_info'];
                this.formData.error_no = data['error_no'];
            }
        }
    }
    render(h) {
        return (
            <Modal title={this.operate + '方案'} width="800" v-model={this.visible} mask-closable={false} on-on-cancel={this.close}>
                <i-form ref="formValidate" labelWidth={100} model={this.formData} rules={this.rules}>
                    <form-item label="报错信息" prop="error_info" style="display: inline-block;width:55%" required>
                        <Input placeholder="请输入" v-model={this.formData.error_info} />
                    </form-item>
                    <form-item label="报错号" prop="error_no" style="display: inline-block;width:55%" required>
                        <Input placeholder="请输入" v-model={this.formData.error_no} />
                    </form-item>
                </i-form>
                <div slot="footer">
                    <Button type="primary" ghost on-click={this.close}>
                        取消
                    </Button>
                    <Button type="primary" on-click={this.save} loading={this.loading}>
                        保存
                    </Button>
                </div>
            </Modal>
        );
    }
}

export default function solutionKeyAddModel(operate: string, id?: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
        modalFactory<solutionKeyVOI.PropsI>(SolutionKeyAddModel)({
            id,
            operate,
            saveSuccess() {
                resolve(true);
            },
            cancel() {
                resolve(false);
            },
        });
    });
}